import {
  ADVERTISEMENT_CATEGORY_SUCCESS,
  ADVERTISEMENT_CATEGORY_FAIL,
  LOAD_ADVERTISEMENT_CATEGORY
} from '../action.types';
import initialState from '../initial.state';

export default function(state = initialState.advertisementCategory, action) {
  switch (action.type) {
    case ADVERTISEMENT_CATEGORY_SUCCESS:
      return { ...action.payload.data };
    case ADVERTISEMENT_CATEGORY_FAIL:
      return state;
    case LOAD_ADVERTISEMENT_CATEGORY:
      return { ...action.advertisementCategory };
    default:
      return state;
  }
}
